(function () {
  "use strict";

  var cart = document.querySelector("[data-jst-cart]");
  if (!cart) return;
  var form = cart.querySelector("#jst-cart-form");
  if (!form) return;

  var timer = 0;
  var pending = null;
  var controller = null;
  var feedback = form.querySelector("[data-cart-feedback]");

  function money(cents) {
    var format = (window.JUSTSTART && window.JUSTSTART.moneyFormat) || "${{amount}}";
    var amount = Number(cents || 0) / 100;
    var token = (format.match(/\{\{\s*(amount(?:_[a-z_]+)?)\s*\}\}/) || [])[1];
    if (!token) return amount.toFixed(2);
    var decimals = token.indexOf("no_decimals") === -1 ? 2 : 0;
    var decimalMark = token.indexOf("comma_separator") > -1 ? "," : ".";
    var thousandsMark = token.indexOf("comma_separator") > -1 ? "." : token.indexOf("apostrophe_separator") > -1 ? "'" : ",";
    var parts = amount.toFixed(decimals).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    return format.replace(/\{\{\s*amount(?:_[a-z_]+)?\s*\}\}/, parts[0] + (decimals ? decimalMark + parts[1] : ""));
  }

  function setFeedback(message) {
    if (feedback) feedback.textContent = message || "";
  }

  function setBusy(line, busy) {
    if (!line) return;
    if (busy) line.setAttribute("aria-busy", "true");
    else line.removeAttribute("aria-busy");
    var input = line.querySelector("[data-quantity-input]");
    if (input) input.removeAttribute("aria-busy");
  }

  function updateCounts(itemCount) {
    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = itemCount;
      node.hidden = itemCount < 1;
    });
    var pageCount = cart.querySelector("[data-cart-page-count]");
    if (pageCount) pageCount.textContent = itemCount + " " + (pageCount.dataset.itemsLabel || "");
  }

  function syncCart(nextCart, line) {
    updateCounts(nextCart.item_count);
    var subtotal = form.querySelector("[data-cart-subtotal]");
    if (subtotal) subtotal.textContent = money(nextCart.total_price);
    var key = line && line.dataset.lineId;
    var item = key && nextCart.items.find(function (candidate) { return candidate.key === key; });
    if (!item) {
      if (line) line.remove();
    } else {
      var input = line.querySelector("[data-quantity-input]");
      var total = line.querySelector(".jst-cart__line-total");
      if (input) {
        input.value = item.quantity;
        input.defaultValue = item.quantity;
      }
      if (total) total.textContent = money(item.final_line_price);
    }
    if (nextCart.item_count < 1) window.location.reload();
  }

  function endpoint() {
    var route = (window.JUSTSTART && window.JUSTSTART.routes && window.JUSTSTART.routes.cart_change) || "/cart/change";
    return route.indexOf(".js") === -1 ? route.replace(/\/$/, "") + ".js" : route;
  }

  function commit() {
    window.clearTimeout(timer);
    if (!pending) return Promise.resolve(true);
    var job = pending;
    pending = null;
    if (controller) controller.abort();
    controller = new AbortController();
    setBusy(job.line, true);
    setFeedback("");
    return fetch(endpoint(), {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: job.key, quantity: job.quantity }),
      credentials: "same-origin",
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error("cart-update-failed");
      return response.json();
    }).then(function (nextCart) {
      syncCart(nextCart, job.line);
      setBusy(job.line, false);
      return true;
    }).catch(function (error) {
      setBusy(job.line, false);
      if (error.name === "AbortError") return false;
      var input = job.line && job.line.querySelector("[data-quantity-input]");
      if (input) input.value = input.defaultValue;
      setFeedback((window.JUSTSTART && window.JUSTSTART.i18n && window.JUSTSTART.i18n.cartUpdateError) || "Cart update failed.");
      return false;
    });
  }

  function queue(line, quantity) {
    if (!line) return;
    pending = { line: line, key: line.dataset.lineId, quantity: Math.max(0, Number(quantity || 0)) };
    window.clearTimeout(timer);
    timer = window.setTimeout(commit, 220);
  }

  form.addEventListener("click", function (event) {
    var quantityButton = event.target.closest("[data-quantity-minus], [data-quantity-plus]");
    if (quantityButton) {
      var line = quantityButton.closest("[data-line-id]");
      var input = line && line.querySelector("[data-quantity-input]");
      if (!input) return;
      input.value = Math.max(0, Number(input.value || 0) + (quantityButton.hasAttribute("data-quantity-plus") ? 1 : -1));
      queue(line, input.value);
      return;
    }
    var remove = event.target.closest("[data-remove]");
    if (remove) {
      event.preventDefault();
      var removeLine = remove.closest("[data-line-id]");
      if (removeLine) queue(removeLine, 0);
      commit();
      return;
    }
    var checkout = event.target.closest('[name="checkout"]');
    if (checkout && pending) {
      event.preventDefault();
      commit().then(function (updated) { if (updated) checkout.click(); });
    }
  });

  form.addEventListener("change", function (event) {
    if (!event.target.matches("[data-quantity-input]")) return;
    event.target.value = Math.max(0, Number(event.target.value || 0));
    queue(event.target.closest("[data-line-id]"), event.target.value);
  });
})();
